<template>
  <div class="order-forQy">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="客户信息" name="first">
          <el-scrollbar>
            <div style="width: 100%">
              <el-col :span="8">
                <el-form-item label="订单编号">
                  <el-input v-model="form.fBillNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="合同号">
                  <el-input
                    v-model="form.fContractNo"
                    :disabled="form.readOnly"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经销商名称">
                  <el-input :value="form.fDistributor" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户">
                  <el-input :value="form.fCustomer" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票名称">
                  <el-input :value="form.fBillingName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货人">
                  <el-input :value="form.fName_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话">
                  <el-input :value="form.fPhone" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货地址">
                  <el-input :value="form.fAddress_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运费付款方式">
                  <el-input :value="form.fPayType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="仓库">
                  <el-input :value="form.fStock" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发货方式">
                  <el-input :value="form.fDeliverType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="交货日期">
                  <el-input :value="form.fDate" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="付款比例(%)" prop="fDeductionRatio">
                  <el-input-currency
                    v-model="form.fDeductionRatio"
                    :scale="2"
                    min="0"
                    max="100"
                    :disabled="form.readOnly"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="备注">
                  <el-input
                    v-model="form.fDes"
                    disabled
                    type="textarea"
                    :rows="4"
                  />
                </el-form-item>
              </el-col>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="订单信息" name="second">
          <el-scrollbar>
            <el-table :data="form.entrys" @row-click="tableChange">
              <el-table-column label="产品编号" prop="fNumber" />
              <el-table-column label="产品名称" prop="fName" />
              <el-table-column label="规格" prop="fModel" />
              <el-table-column label="单位" prop="fUnit" />
              <el-table-column label="数量" prop="fQty" />
              <el-table-column label="订单价" prop="fOrderPrice" />
              <el-table-column label="优惠价">
                <template slot-scope="scope">
                  <el-input-currency
                    v-model="scope.row.fPrice"
                    :scale="2"
                    :disabled="form.readOnly"
                    @input="changeValue(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column label="小计">
                <template
                  slot-scope="scope"
                ><span>{{ scope.row.total }}</span></template>
              </el-table-column>
              <el-table-column label="备注" prop="fDes" />
            </el-table>
            <div style="text-align:right;padding-right:17%;margin-top:10px;">
              合计:{{ total }}
            </div>
            <hr>
            <div style="text-align:right;padding-right:17%;margin-bottom:3%;">
              付款比例:{{ form.fDeductionRatio }}%
              付款金额:{{ totalRatio }}
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="canAudit" label="确认" name="four">
          <el-form
            ref="form"
            v-loading="loading"
            :model="form"
            :rules="rules"
            label-width="78px"
            style="overflow: auto"
          >
            <el-form-item
              v-if="canAudit"
              label="审批意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <el-button
            v-if="canAudit"
            type="primary"
            :disabled="saving"
            style="margin-left: 78px"
            @click="submit(1)"
          >通过</el-button>
          <el-button
            v-if="canAudit"
            type="warning"
            :disabled="saving"
            style=""
            @click="submit(2)"
          >回退</el-button>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'

export default {
  inject: ['getMap'],
  data: function() {
    return {
      form: {
        procedureInfo: {},
        entrys: []
      },
      isId: null,
      rules: { fDeductionRatio: [{ required: true, message: '必填项', trigger: 'change' }] },

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canAudit: function() {
      // console.log(this.form, 'this.form')

      if (this.form) {
        if (this.form.readOnly == false) {
          return true
        }
      }
      return false
    },
    total: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return t.toFixed(2)
    },
    totalRatio: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return (t * Number(this.form.fDeductionRatio) / 100).toFixed(2)
    }
  },
  watch: {
    // 'scope.row.fPrice': function(row, value) {
    //   console.log(row, 'row')
    //   console.log(value, 'value')
    // }
  },
  mounted() {},
  methods: {
    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.form.procedureInfo.fType = type
          if (type == 2) {
            if (!this.form.procedureInfo.fOpinion) {
              this.$message.error('请填写审核意见')
              return
            }
            const h = this.$createElement
            this.form.procedureInfo.returnNode = await new Promise(
              (resolve, reject) => {
                this.$formDlg({
                  title: '选择回退节点',
                  formTpl: <ReturnNode name={'Order_wl_s'}></ReturnNode>,
                  formSubmit: resolve,
                  width: '30%'
                })
              }
            )
          } else {
            this.form.procedureInfo.returnNode = null
          }

          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true

          this.$httpPost('OrderManage/OrderForWls/OrderForWlsApproval', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist)

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/logisticsAudit' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'OrderManage/OrderForWls/GetOrderForWls',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      const date = res.datalist.fDate
      if (date == undefined || date == null) {
        this.form.fDate = ''
      }
      this.form.fDate = moment(date).format('YYYY-MM-DD ')
      this.form.entrys.forEach(val => {
        console.log(val, 'vc')
      })
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    changeValue(value) {
      // console.log(value, 'val')
      this.form.entrys.forEach((val) => {
        if (val.fEntryID == value.fEntryID) {
          val.total = (value.fPrice * val.fQty).toFixed(2)
        }
      })
    },

    tableChange(row) {
      this.isId = row.fEntryID
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == null) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.order-forQy {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;

    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 150px);
      .el-tab-pane {
        height: calc(100vh - 150px);
      }
    }
  }
}
</style>
